import { Button } from "@mui/material";
import React from "react";
import { useStyles } from "../Common/CommonStyle";
import DialogBox from "../Common/DialogBox";
import LinearProgressBar from "../Common/LinearProgressBar";
import VideoPlayer from "../Common/VideoPlayer";

export interface IScanningMeasures {
  displayNextSlide: () => void;
}

const ScanningMeasures = (props: IScanningMeasures) => {
  const classes = useStyles();
  const [nextSlide, showNextSlide] = React.useState(0);
  const [progressComplete, setProgressComplete] = React.useState(0);
  const displayNextSlide = () => {
    showNextSlide(1);
  };
  const statusComplete = () => {
    setProgressComplete(progressComplete + 1);
  };

  React.useEffect(() => {
    if (progressComplete === 4) props.displayNextSlide();
  }, [progressComplete]);

  const preventiveProgressScan = (
    <div
      style={{
        flexDirection: "column",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "20%",
      }}
    >
      <LinearProgressBar
        message={"Isolating hospital email servers from the spam email..."}
        statusComplete={statusComplete}
        timeInterval={1000}
      />
      <LinearProgressBar
        statusComplete={statusComplete}
        message={"Deleting email in question..."}
        timeInterval={1200}
      />
      <LinearProgressBar
        statusComplete={statusComplete}
        message={"Securing patient databases..."}
        timeInterval={1400}
      />
      <LinearProgressBar
        statusComplete={statusComplete}
        message={"Restricting access to ports..."}
        timeInterval={1600}
      />
      <Button>Pause</Button>
    </div>
  );
  return (
    <div
      className={classes.positionComponent}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <VideoPlayer
        videoURL={"asset/video/ScanningProgressVideo.mp4"}
        displayNextSlide={displayNextSlide}
        styles={{
          position: "absolute",
          left: "27%",
          top: "8rem",
          marginTop: "0rem",
          height: "55%",
          width: "70%",
        }}
      />
      <DialogBox childProps={preventiveProgressScan} type={2}></DialogBox>
    </div>
  );
};

export default ScanningMeasures;
